module.exports = { "default": require("core-js/library/fn/object/freeze"), __esModule: true };


/*****************
 ** WEBPACK FOOTER
 ** /Users/nw/flint/flintjs-deps/~/babel-runtime/core-js/object/freeze.js
 ** module id = 95
 ** module chunks = 1
 **/